"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _default = exports["default"] = function _default(obj) {
  var values = [];
  if (obj) {
    var _context;
    (0, _forEach["default"])(_context = (0, _keys["default"])(obj)).call(_context, function (element) {
      values.push(obj[element]);
    });
  }
  return values;
};